"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaneTitle = void 0;
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const PaneTitle = ({ title, color = undefined, offset = 0, bold = false }) => {
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Pane_1.default, { grow: true },
        react_1.default.createElement(Text_1.default, { variant: "h2", color: color, style: {
                paddingLeft: offset,
                paddingTop: offset,
                fontFamily: bold ? 'Gilroy' : undefined,
            } }, title))), [bold, color, offset, title]);
};
exports.PaneTitle = PaneTitle;
exports.default = exports.PaneTitle;
